import * as React from "react"
import {CSSProperties} from "react"
import Appointment from "../../model/appointment/Appointment";
import AppointmentRow from "./AppointmentRow";
import {Option} from "ts-option";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../navigation/route/Route";
import JobAppointment from "../../model/appointment/job/JobAppointment";

const classNames = require("classnames");

interface ComponentProps {
	/**
	 * Appointments.
	 */
	appointments: Option<(Appointment | JobAppointment)[]>
	/**
	 * Edit appointment action.
	 * @param {Appointment} appointment.
	 */
	editAppointment?: (appointment: Appointment) => void

	/**
	 * Appointment change status callback
	 * @param {Appointment} appointment
	 */
	onAppointmentStatusChange?: (appointment: Appointment) => void;
	/**
	 * Custom styles.
	 */
	style?: CSSProperties;
	/**
	 * Readonly flag
	 */
	readonly?: boolean
	/**
	 * Custom class for appointments table.
	 */
	tableCustomClass?: string
	/**
	 * Lead form contact. Needed to show appointment confirmation during lead creation.
	 */
	leadFormContactId: Option<string>;
}

type Props = ComponentProps & RouteComponentProps<{}>

/**
 * Appointments table.
 */
class AppointmentsTable extends React.Component<Props, {}> {
	render() {
		const appointments = this.props.appointments.getOrElse([]);
		const classes = classNames({
			"l-table-default": true,
			[`${this.props.tableCustomClass}`]: this.props.tableCustomClass
		});
		return (
			<table className={classes} style={this.props.style}>
				<thead>
				<tr>
					<th>Date</th>
					<th>Time</th>
					<th>Status</th>
					{this.props.readonly && <th>ID</th>}
					{this.props.readonly && <th>Assignees</th>}
					<th>Actions</th>
					{this.props.readonly && <th>Last Sent</th>}
				</tr>
				</thead>
				<tbody>
				{appointments.map(item => (
					<AppointmentRow onClick={() => this.onRowClick(item)}
									key={item.id}
									appointment={item}
									editAppointment={this.props.editAppointment}
									onAppointmentStatusChange={this.props.onAppointmentStatusChange}
									readonly={this.props.readonly}
									leadFormContactId={this.props.leadFormContactId}/>
				))}
				</tbody>
			</table>
		);
	}

	onRowClick(appointment: Appointment | JobAppointment) {
		if (appointment instanceof Appointment) {
			appointment.referenceNumber.map(lrn => this.props.history.push(Routes.EditLead(lrn)));
		}
		else {
			appointment.referenceNumber.map(jrn => this.props.history.push(Routes.EditJob(jrn)))
		}
	}
}

export default withRouter<ComponentProps>(AppointmentsTable)